// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { Toastr } from "@revvsales/components";
import { ConfirmationBox } from "../../../../commonComponents";

// Actions Imports
import {
  fetchAndUpdateDocMeta,
  resetDocToDraft,
} from "../../../../actions/DocumentActions";

// Internal Imports
import { AmplitudeUtils } from "../../../../utils";
import { EVENTS } from "../../../../constants";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

class EsignWarningOnApprovedStage extends Component {
  state = {};

  _resetDocumentToDraftStage = () => {
    const {
      documentID,
      documentNumber,
      documentStatus,
      documentTag,
      templateID,
    } = this.props;
    // Trigger Amplitude Event
    amplitudeLogEvent(EVENTS.EVENT_NAMES.EDIT_DOCUMENT_CLICKED, {
      documentID,
      status: documentStatus,
      tag: documentTag,
      templateID,
    });

    // Trigger API request to change the doc stage to draft
    this.props
      .resetDocToDraft(documentID)
      .then(() => {
        this.props
          .fetchAndUpdateDocMeta(documentNumber)
          .then(() => {
            Toastr.showToastr({
              type: "success",
              message: "Document moved to Drafts successfully!",
              timeout: 3000,
            });
            this._onClose();
          })
          .catch(error => {
            console.error(
              "MoveDocStageToDraft => _resetDocumentToDraftStage => this.props.fetchAndUpdateDocMeta: Error",
              error,
            );
            this._onClose();
          });
      })
      .catch(error => {
        console.error(
          "MoveDocStageToDraft => _resetDocumentToDraftStage => this.props.resetDocToDraft: Error",
          error,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
        this._onClose();
      });
  };

  _onClose = () => {
    this.props.closePopup({ showEsignWarningOnApprovedStagePopup: false });
  };

  render() {
    const tempSubHeader = (
      <p>
        You seem to have missed adding signer blocks or details before sending
        the document for approval. Please click{" "}
        <b>
          <i>Edit Document </i>
        </b>
        to add signature blocks or signer details and then click eSign. Your
        document may need to pass the auto-approval process again.
      </p>
    );
    return (
      <ConfirmationBox
        show={this.props.showEsignWarningOnApprovedStagePopup}
        closePopup={this._onClose}
        header="🔒 Please edit this document and add signature blocks"
        subHeader={tempSubHeader}
        checkboxLabel="Edit document."
        cancelBtnText="Cancel"
        data={this.props.documentID}
        confirmAction={this._resetDocumentToDraftStage}
        okBtnText="Edit document"
        disableCheckbox
        closeOnOverlayClick={false}
      />
    );
  }
}

const mapStateToProps = state => {
  const {
    document: {
      docNo: documentNumber,
      documentStatus: docStatus,
      documentTag: docTag,
      id: documentID,
      template_id: templateID,
    },
  } = state.DocumentStore;

  // Local Assignments
  const documentStatus = (docStatus && docStatus.name) || "";
  const documentTag = (docTag && docTag.name) || "";

  return {
    documentID,
    documentNumber,
    documentStatus,
    documentTag,
    templateID,
  };
};

const mapDispatchToProps = {
  fetchAndUpdateDocMeta,
  resetDocToDraft,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EsignWarningOnApprovedStage);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/EsignWarningOnApprovedStage/index.js